var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modal-terms",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modal-terms",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural)) +
                  " Selected"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "talent-list modal-body" }, [
            _c(
              "ul",
              _vm._l(_vm.talents, function (talent) {
                return _c(
                  "li",
                  { key: talent.id, staticClass: "talent-name" },
                  [_vm._v(_vm._s(talent.name))]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          !_vm.$vlastMode
            ? _c("div", { staticClass: "modal-header" }, [
                _c("h4", { staticClass: "modal-title" }, [
                  _vm._v("Terms and Conditions"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vlastMode
            ? _c("div", { staticClass: "modal-body" }, [
                _c("p", { staticClass: "lead" }, [
                  _vm._v("\n          Please read the full "),
                  _c(
                    "a",
                    { attrs: { href: _vm.bookingTncLink(), target: "_blank" } },
                    [_vm._v("Terms & Conditions here")]
                  ),
                  _vm._v(
                    ", then agree to proceed with your booking.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "terms-and-conditions" }, [
                  _c("li", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "checkbox checkbox-primary" }, [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            name: "term_one",
                            id: "term_one",
                            disabled: "",
                            checked: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "term_one" } }, [
                          _vm._v(
                            "\n                  You'll stick to the brief. You will not ask the " +
                              _vm._s(_vm.$starLabel) +
                              " to do anything that is not written and agreed to e.g. stay at the event for longer, extra social media posts etc.\n                "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("li", [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "checkbox checkbox-primary" }, [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            name: "term_three",
                            id: "term_three",
                            disabled: "",
                            checked: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "term_three" } }, [
                          _vm._v(
                            "\n                  You need to pay your deposit urgently. You understand that until the deposit is paid, the talent may accept other booking requests (unless otherwise agreed upon by " +
                              _vm._s(this.clientName) +
                              ").\n                "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-lg pull-left",
                  attrs: { "data-dismiss": "modal" },
                  on: { click: _vm.hide },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c("ladda-button", {
                staticClass: "btn btn-primary btn-lg",
                attrs: {
                  disabled: _vm.cannotAcceptTermsAndConditions,
                  click: _vm.handleAcceptTermsAndConditionsCallback,
                },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$vlastMode ? "Confirm Booking" : "I Agree"
                  ),
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "checkbox checkbox-primary checkbox-lg" }, [
          _c("input", {
            attrs: {
              type: "checkbox",
              name: "term_two",
              id: "term_two",
              disabled: "",
              checked: "",
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "term_two" } }, [
            _vm._v(
              "\n                  You'll only use approved promotional images. For example, you won't use photos of athletes wearing league licensed attire or other licensed imagery for promotional purposes (eg featuring league logos, club logos, team sponsor logos).\n                "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }